import axios from "axios";
import { apiURL } from "../config";

export default axios.create({
	baseURL: apiURL,
});

export const axiosPrivate = axios.create({
	baseURL: apiURL,
	headers: {
		// "Content-Type": "application/json",
		// "Access-Control-Allow-Credentials": "true",
		// "Access-Control-Allow-Origin": "*",
		// "Access-Control-Allow-Headers": "*",
	},
	// withCredentials: true,
});
